import React from "react";
import { useNavigate  } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { revertAllArticles } from "../../redux/articleSlice.js";
import { revertAllBlogs } from "../../redux/blogSlice.js";
import { revertAllHirings } from "../../redux/hiringSlice.js";
import { revertAllHiringContacts } from "../../redux/hiringContactSlice.js";
import { revertAllStats } from "../../redux/statSlice.js";
import {revertAllToolboxPartners} from "../../redux/toolboxPartnerSlice"
import { revertAllAwards } from "../../redux/awardSlice.js";
import {revertAllVideos} from "../../redux/videoSlice";
import {revertAllParams} from "../../redux/paramSlice.js";


import { logout } from "../../redux/authSlice.js";
import { globals } from "../Globals/Globals.js";

// reactstrap components
import {
    Button,
    Row,
    Col,
  } from "reactstrap";

import {  } from "../../Components/Globals/Globals.js";
import "./CustomTabset.css";
import {openModalStat, openModalArticle, openModalBlog, openModalAward, openModalToolbox, openModalVideo, openModalHiring, openModalHiringContactForm} from "../../redux/modalSlice.js"

const CustomTabset = (props) => {
  const {statCount} = useSelector((store) => store.stats)
  const {articleCount} = useSelector((store) => store.articles)
  const {blogCount} = useSelector((store) => store.blogs)
  const {hiringCount} = useSelector((store) => store.hirings)
  const {hiringContactCount} = useSelector((store) => store.hiringContacts)
  const {awardCount} = useSelector((store) => store.awards)
  const {toolboxPartnerCount} = useSelector((store) => store.toolbox)
  const {videoCount} = useSelector((store) => store.video)
  const {user_email} = useSelector((store) => store.auth)

  let dispatch = useDispatch();
  let navigate = useNavigate();

   /**
   * Prototype : change_tabset
   * @param {*} p_s_next_tabset 
   */
  const change_tabset = (p_s_next_tabset, p_s_next_url) => {
    navigate(p_s_next_url)
  }

  const active_color = "rgb(110.4398104265, 199.3360189573, 224.2601895735)"
  const inactive_color = "#bcb4b4"

    return (
        <div className="custom-tabset">
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="12" xs="12">
                    <h2 className="discover-title">
                      <small>Admin console - {globals.dico.version}</small>
                      {globals.parameters.debugging &&
                      <b>{props.activeTabset}</b>}
                    </h2>
                    <small>({user_email})</small>
                  </Col>
                </Row>
                {/** Items tabset */}
                <Row>
                  <Button 
                    onClick={()=>{change_tabset("stats", "/stats-page")}}
                    style={{ backgroundColor: (props.activeTabset == "stats") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{statCount} </b> Statistiques</Button>
                  <Button 
                    onClick={()=>{change_tabset("articles", "/articles-page")}}
                    style={{ backgroundColor: (props.activeTabset == "articles") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{articleCount} </b>Articles</Button>
                  <Button 
                    onClick={()=>{change_tabset("blogs", "/blogs-page")}}
                    style={{ backgroundColor: (props.activeTabset == "blogs") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{blogCount} </b>Blogs</Button>
                  <Button 
                    onClick={()=>{change_tabset("awards", "/awards-page")}}
                    style={{ backgroundColor: (props.activeTabset == "awards") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{awardCount} </b>Hôtel du mois</Button>
                  <Button 
                    onClick={()=>{change_tabset("toolbox", "/toolbox-page")}}
                    style={{ backgroundColor: (props.activeTabset == "toolbox") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{toolboxPartnerCount} </b>Partenaires</Button>
                  <Button 
                    onClick={()=>{change_tabset("video", "/video-page")}}
                    style={{ backgroundColor: (props.activeTabset == "video") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{videoCount} </b>Vidéo</Button>
                  <Button 
                    onClick={()=>{change_tabset("offres d'emploi", "/hiring-page")}}
                    style={{ backgroundColor: (props.activeTabset == "hirings") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{hiringCount} </b>Offres d'emploi</Button>
                  {globals.parameters.hiring_contact_feature_enabled && <Button 
                    onClick={()=>{change_tabset("contacts d'emploi", "/hiringContacts-page")}}
                    style={{ backgroundColor: (props.activeTabset == "hiringContacts") ? active_color : inactive_color }}><b style={{color:"red", fontWeight:"bolder", fontSize:"Larger"}}>{hiringContactCount} </b>Contacts d'emploi</Button>}
                </Row>

                {/** Add items buttons */}
                <hr/>
                <Row>
                {/** Add stat button */}
                {(props.activeTabset == "stats") &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalStat({stat_data_guid:null, read_only:false}))}}
                  >Nouvelle statistique</Button>}

                {/** Add article button */}
                {(props.activeTabset == "articles") &&(articleCount <globals.parameters.max_articles) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalArticle({article_data_guid:null, read_only:false}))}}
                  >Nouvel article</Button>}

                {/** Add blog button */}
                {(props.activeTabset == "blogs") &&(blogCount <globals.parameters.max_blogs) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalBlog({blog_data_guid:null, read_only:false}))}}
                  >Nouveau blog</Button>}

                {/** Add award button */}
                {(props.activeTabset == "awards") &&(awardCount <globals.parameters.max_awards) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalAward({award_data_guid:null, read_only:false}))}}
                  >Ajouter un hôtel du mois</Button>}

                {/** Add toolbox partners button */}
                {(props.activeTabset == "toolbox") &&(toolboxPartnerCount <globals.parameters.max_toolboxes) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalToolbox({toolbox_data_guid:null, read_only:false}))}}
                  >Ajouter un partenaire toolbox</Button>}

                {/** Add video button */}
                {(props.activeTabset == "video") &&(videoCount <globals.parameters.max_videos) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalVideo({video_data_guid:null, read_only:false}))}}
                  >Nouvelle vidéo</Button>}

                {/** Add hiring button */}
                {(props.activeTabset == "hirings") &&(hiringCount <globals.parameters.max_hirings) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalHiring({hiring_data_guid:null, read_only:false}))}}
                  >Nouvelle offre d'emploi</Button>}

                {/** Add hiringContact button */}
                {(props.activeTabset == "hiringContacts") &&(hiringContactCount <globals.parameters.max_hiringContacts) &&
                  <Button 
                  style={{ backgroundColor:"green"}}
                    onClick={()=>{dispatch(openModalHiringContactForm({hiringContact_data_guid:null, read_only:false}))}}
                  >Nouveau contact d'emploi</Button>}

                {/** Disconnect button anyway */}
                  <Button 
                  style={{ backgroundColor:"orange"}}
                    onClick={()=>{
                                  dispatch(logout());
                                  dispatch(revertAllStats());
                                  dispatch(revertAllHirings());
                                  dispatch(revertAllHiringContacts());
                                  dispatch(revertAllArticles());
                                  dispatch(revertAllBlogs());
                                  dispatch(revertAllAwards())
                                  dispatch(revertAllToolboxPartners());
                                  dispatch(revertAllVideos());
                                  dispatch(revertAllParams());
                                }}
                  >Deconnexion</Button>
                </Row>

        </div>
    )
}

export default CustomTabset;